import React, { useState, useEffect } from "react"
import StatesNav from "../Nav/StatesNav"
import Loader from "../Loader"

import "../../assets/styles/pages/home.scss"

// custom hook
import useGetPlots from "../../hooks/useGetPlot"

export default function Embed() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth || null)
  const [viewPort, setViewPort] = useState(null)

  useEffect(() => {
    window &&
      window.addEventListener("resize", () => setWindowWidth(window.innerWidth))
    if (windowWidth >= 320) {
      setViewPort("small")
    }
    if (windowWidth >= 780) {
      setViewPort("medium")
    }
    if (windowWidth >= 1024) {
      setViewPort("large")
    }
  }, [windowWidth])

  const [err, loading, displayPlot] = useGetPlots("homepage", viewPort)

  if (loading) return <Loader />
  if (err) return <div>Error...</div>

  return (
    <div className="page-home">
      <div className="container">
        <div className="wrapper">
          <div className="content">            
          
            <div style={{ margin: "45px 0 15px 0", display:"none" }}>
              <StatesNav />
            </div>

            {displayPlot("map")}
            <small style={{ display: "block", marginTop: 30 }}>The state settlement amounts were determined by a variety of factors, including opioid pills distributed in the state, number of fatal opioid overdoses and state population. These dollar amounts reflect settlements finalized by early 2022. There are additional pending state litigation cases, and the map will update accordingly.
            </small>  
          
          </div>
        </div>
      </div>
    </div>
  )
}
